import React from 'react';

const Header = () => (
    <div className="header__container">
      <div className="header__container-inner">
        <div>
          <h2 className="title is-4 has-text-centered has-text-weight-bold">Who collects race data?</h2>
          <h2 className="subtitle is-6 has-text-centered">The Pennsylvania State Police is one of only 11 statewide police agencies that doesn't collect race data during traffic stops, and by far the largest.
          </h2>
        </div>
      </div>
    </div>
)

export default Header